<template>
  <view class="checkbox-desc-support-demo">
    <view-desc>支持描述文案：{{ checkboxValue }}</view-desc>
    <view class="cube-checkbox-example">
      <cube-checkbox  option="{{ option }}" shape="square" wx:model="{{ checkboxValue }}" wx:model-prop="value">
      </cube-checkbox>
    </view>
  </view>
</template>

<script>
import { createComponent } from '@mpxjs/core'

createComponent({
  options: {
    styleIsolation: 'shared'
  },
  data: {
    option: {
      value: '橘子🍊',
      text: '选择一',
      desc: '橘子🍊',
      position: 'right'
    },
    checkboxValue: false
  }
})
</script>

<style lang="stylus">
.cube-checkbox-example
  padding 5px 10px
  background-color #fff
.desc
  margin-top 15px
</style>

<script type="application/json">
  {
    "styleIsolation": "shared",
    "component": true,
    "usingComponents": {
      "view-desc": "../../components/desc/index",
      "cube-checkbox": "@mpxjs/mpx-cube-ui/src/components/checkbox/index"
    }
  }
</script>
